<div class="footer--piva--pagamento">
  <div class="footer--piva">
    <div class="shipping-info">
      <img src="/assets/images/ico-lock-very.svg" class="payment-icon" alt="Transazioni sempre sicure" style="display: inline-block; margin-right: 5px;" />
      Transazioni sempre sicure
    </div>
    <div class="piva">
      <span style="display: inline-block; width: 16px; text-align: center;">&copy;</span>
      Very Mobile - Partita IVA: 13378520152
    </div>
  </div>
  <div class="footer--pagamento">
    <span class="footer--pagamento-text">METODI DI PAGAMENTO</span>
    <span class="footer--pagamento-icon">
      <img src="/assets/images/icon-payment-visa-color.svg" class="payment-icon" alt="Payment visa"/>
      <img src="/assets/images/icon-payment-paypal.svg" class="payment-icon" alt="Payment paypal"/>
      <img src="/assets/images/icon-payment-postepay-color.svg" class="payment-icon" alt="Payment postpay"/>
      <img src="/assets/images/icon-payment-mastercard-color.svg" class="payment-icon" alt="Payment master"/>
      <img src="/assets/images/icon-payment-amex-color.svg" class="payment-icon" alt="Payment American Express"/>
    </span>
  </div>

</div>
<div class="sb-actions-container" [ngClass]="{
  'sticky': isSticky
}"  *ngIf="isStickyHide">
<div class="row sb-actions" [ngClass]="{
  'sticky': isSticky
}">
  <div class="sb-actions__item" >
    <wt-button [cssClasses]="['sb-button-back']" wt-secondary (click)="goToPreviousStep()" *ngIf="hasBack && !showCloseButton">
      <span class="sb-button-back__icon"></span>
      <span class="sb-button-back__text">{{'STEP.ACTIONS.GO-BACK' | translate}}</span>
    </wt-button>
    <wt-button [cssClasses]="['sb-button-back']" wt-secondary (click)="onCloseButton()" *ngIf="showCloseButton">
      <span class="sb-button-back__text">{{'STEP.ACTIONS.CLOSE' | translate}}</span>
    </wt-button>
  </div>
  <div class="sb-actions__item sb-actions-submit first-in-vertical">
    <wt-button [disabled]="submitDisabled" type="submit" wt-primary (click)="onSubmit()" *ngIf="hasSubmit">
      {{text | translate}}
    </wt-button>
    <div class="sb-paypal-container" [class.sb-paypal-container--visible]="showPaypalContainer">
    </div>
    <div class="sb-upper-container" [class.sb-upper-container--visible]="showUpperContainer">
      <ng-content></ng-content>
    </div>
  </div>
</div>
</div>
